module.exports = __webpack_public_path__ + "img/t_0002.5dd261b2.gif";